import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { IPropLabelQuiz } from "../../../models/interactions/PropLabelQuiz";
import { useTrainingLocalization } from "../../trainingLocalization/TrainingLocalizationHooks";
import PiInteractionTitlePreview from "../components/PiInteractionTitlePreview";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiQuizTextfield from "../components/PiQuizTextfield";
import PropLabelQuizPreviewBody from "./PropLabelQuizPreviewBody";
import "./PropLabelQuizPreview.css";

type PropLabelQuizPreviewProps = {
  ordered?: boolean;
};

export default function PropLabelQuizPreview({
  ordered = false,
}: PropLabelQuizPreviewProps = {}) {
  const quiz = useSelector(selectSelectedElement) as IPropLabelQuiz;
  const [activeDetailAnswerId, setActiveDetailAnswerId] = useState<
    string | null
  >(null);
  const [detailBackRequest, setDetailBackRequest] = useState(0);
  const { getValue, changeValue } = useTrainingLocalization();
  const activeDetailAnswer = quiz.answers.find(
    (answer) => answer.id === activeDetailAnswerId,
  );

  const title = useMemo(
    () =>
      activeDetailAnswer ? (
        <div className="proplabelquiz-detail-title-bar">
          <IconButton
            aria-label="Back to Quiz answers"
            className="proplabelquiz-detail-title-back"
            title="Back"
            onClick={() => setDetailBackRequest((request) => request + 1)}
          >
            <ArrowBackIcon className="text-interaction-primary" />
          </IconButton>
          <div className="proplabelquiz-detail-title-field">
            <PiQuizTextfield
              value={getValue(activeDetailAnswer.text)}
              onChange={(value) => changeValue(activeDetailAnswer.text, value)}
            />
          </div>
        </div>
      ) : (
        <PiInteractionTitlePreview
          value={getValue(quiz.title)}
          onChange={(value) => changeValue(quiz.title, value)}
          placeholder="Quiz Title"
        />
      ),
    [activeDetailAnswer, changeValue, getValue, quiz.title],
  );

  return (
    <PiPopupWindowPreview
      title={title}
      body={
        <PropLabelQuizPreviewBody
          detailBackRequest={detailBackRequest}
          ordered={ordered}
          onActiveDetailAnswerChange={setActiveDetailAnswerId}
        />
      }
      size="large"
    />
  );
}
